"use client";

import { type ReactNode, type RefObject, useRef } from "react";
import { useDebounce, useIntersection } from "react-use";

type Props = {
  children: ReactNode;
  isLoading: boolean;
  onLoadMore: () => void;
};

export function InfiniteScroll({ isLoading, children, onLoadMore }: Props) {
  const sentryRef = useRef<HTMLDivElement>(null);
  const intersection = useIntersection(sentryRef as RefObject<HTMLElement>, {});
  const inView = intersection?.isIntersecting ?? false;
  useDebounce(
    () => {
      if (inView && !isLoading) {
        onLoadMore();
      }
    },
    100,
    [inView, isLoading, onLoadMore],
  );

  return (
    <div className="overflow-hidden">
      {children}
      <div
        ref={sentryRef}
        className={`loading-indeterminate ${isLoading ? "visible" : "invisible"}`}
      />
    </div>
  );
}
